import Badge from "../ui/Badge.jsx";
import { formatShortDate } from "../../utils/adminUserFormat.js";

function statusVariant(st) {
  const s = String(st || "").toLowerCase();
  if (s === "active") return "active";
  if (s === "complete" || s === "completed") return "complete";
  if (s === "paused") return "paused";
  if (s === "archived") return "archived";
  return "info";
}

const thStyle = {
  textAlign: "left",
  padding: "8px 10px",
  fontSize: "11px",
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "var(--text-secondary)",
  borderBottom: "1px solid var(--border)",
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px",
  borderBottom: "1px solid var(--border)",
};

export default function UserDetailProjectsTab({ projects }) {
  const list = Array.isArray(projects) ? projects : [];

  if (!list.length) {
    return (
      <p className="text-secondary" style={{ fontSize: "14px", margin: 0 }}>
        This user has no projects.
      </p>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={thStyle}>Project</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}>Created</th>
            <th style={thStyle}>Updated</th>
          </tr>
        </thead>
        <tbody>
          {list.map((p) => (
            <tr key={p.project_id}>
              <td style={tdStyle}>{p.project_name || "—"}</td>
              <td style={tdStyle}>
                <Badge variant={statusVariant(p.status)}>{p.status || "—"}</Badge>
              </td>
              <td style={tdStyle}>{formatShortDate(p.created_at)}</td>
              <td style={tdStyle}>{formatShortDate(p.updated_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
